<template>
  <g
    :transform="`translate(${deltaX}, ${deltaY})`"
    :class="[{ 'edit-mode': venueReservationTable }, status]"
    @mousedown="onMouseDown"
    @mouseover="setTooltip(true)"
    @mouseout="setTooltip(false)"
    ref="el"
  >
    <g :transform="`translate(${shapeData.x}, ${shapeData.y}) rotate(${shapeData.rotation || 0})`">
      <rect
        v-if="type == TableShape.SQUARE"
        class="table"
        rx="0.3"
        ry="0.3"
        :x="-shapeData.w"
        :y="-shapeData.h"
        :width="shapeData.w * 2"
        :height="shapeData.h * 2"
        :stroke-width="2 / ratio"
      />

      <circle
        v-else-if="type == TableShape.CIRCLE"
        class="table"
        :cx="0"
        :cy="0"
        :r="shapeData.w"
        :stroke-width="2 / ratio"
      />

      <path
        v-else-if="type == TableShape.HALF_CIRCLE"
        class="table"
        :d="`M-${shapeData.w},-${shapeData.h / 2} a1,1 0 0,0 ${shapeData.w * 2},0`"
        stroke-linejoin="round"
      />

      <polygon
        v-else-if="type == TableShape.TRIANGLE"
        class="table"
        :points="trianglePoints"
        :stroke-width="2 / ratio"
        stroke-linejoin="round"
      />

      <polygon
        v-else-if="type == 'polygon'"
        class="table"
        :points="pointsStr"
        :stroke-width="2 / ratio"
      />

      <svg
        v-else-if="type == 'piano'"
        :width="8.1 * shapeData.w"
        :height="6.8 * shapeData.h"
        :x="shapeData.w * -4.05"
        :y="shapeData.h * -3.4"
        class="table"
        viewBox="0 0 81 68"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M73.3922 68L23.4131 68L22.8647 67.9958L22.3251 67.9827L21.7934 67.9615L21.2702 67.932L20.7549 67.8941L20.2478 67.8482L19.7489 67.7945L19.2576 67.7331L18.7745 67.6642L18.5359 67.6266L18.2993 67.5875L18.0645 67.5464L17.8317 67.5034L17.6007 67.4587L17.3717 67.4124L17.1448 67.3641L16.9197 67.314L16.6966 67.2624L16.4752 67.2087L16.2556 67.1536L16.0381 67.0969L15.8226 67.0381L15.6086 66.9779L15.3966 66.9162L15.1864 66.8526L14.9782 66.7876L14.7718 66.7211L14.5671 66.6528L14.3642 66.583L14.1631 66.5117L13.964 66.439L13.7666 66.3644L13.5708 66.2886L13.3769 66.2114L13.1849 66.1327L12.9945 66.0524L12.806 65.9707L12.6189 65.8878L12.4339 65.8034L12.2506 65.7175L12.0687 65.6304L11.889 65.5418L11.7107 65.4521L11.5341 65.3611L11.3593 65.2686L11.186 65.175L11.0144 65.0801L10.8446 64.9838L10.6765 64.8866L10.5099 64.7879L10.3451 64.6882L10.1817 64.5871L10.0201 64.4851L9.86024 64.3819L9.70185 64.2775L9.54491 64.172L9.38973 64.0655L9.23631 63.9578L9.08406 63.8493L8.93386 63.7395L8.78483 63.6289L8.63756 63.517L8.49175 63.4043L8.34741 63.2906L8.20482 63.1761L8.06369 63.0604L7.92403 62.9441L7.78584 62.8266L7.6491 62.7085L7.51413 62.5892L7.38032 62.4693L7.24828 62.3485L7.1174 62.2268L6.98828 62.1042L6.86033 61.981L6.73414 61.857L6.60912 61.7323L6.36376 61.4806L6.12397 61.2259L5.88974 60.9688L5.66107 60.709L5.43797 60.4468L5.22013 60.1823L5.00757 59.9159L4.80056 59.6472L4.59883 59.3767L4.40208 59.1047L4.2103 58.8309L4.0238 58.5556L3.84227 58.2789L3.66572 58.0012L3.49385 57.7223L3.32696 57.4426L3.16475 57.1619L3.00723 56.8807L2.8544 56.5988L2.70595 56.3167L2.5619 56.0342L2.42253 55.7515L2.28756 55.4687L2.15668 55.186L2.0302 54.9033L1.90811 54.6202L1.79011 54.3372L1.67651 54.0542L1.56671 53.7714L1.46131 53.4884L1.35971 53.2056L1.26251 52.9229L1.16881 52.6402L1.07951 52.3577L0.993726 52.0753L0.912038 51.7928L0.834156 51.511L0.759786 51.2288L0.689518 50.9473L0.622763 50.666L0.559519 50.3848L0.500082 50.1038L0.444161 49.8235L0.391752 49.5431L0.342856 49.2634L0.297474 48.9839L0.255311 48.7047L0.216664 48.4262L0.181236 48.1479L0.149322 47.8702L0.120336 47.5929L0.0948641 47.3161L0.0723184 47.0399L0.0529938 46.764L0.0365976 46.4888L0.0234227 46.2144L0.0131762 45.9403L0.00585605 45.6668L0.00146438 45.3942L-1.00002e-06 45.1222L0.00146436 44.8508L0.00556337 44.5803L0.012296 44.31L0.0219594 44.041L0.0342565 43.7726L0.0491894 43.5051L0.066756 43.2381L0.0866659 42.9721L0.109209 42.7069L0.134389 42.4427L0.161619 42.1793L0.191485 41.9172L0.223689 41.6556L0.25824 41.3949L0.294838 41.1355L0.334073 40.8769L0.375063 40.6195L0.418394 40.363L0.463776 40.1074L0.560689 39.6001L0.665508 39.0969L0.77794 38.5986L0.897689 38.105L0.960347 37.8601L1.02505 37.6164L1.09152 37.374L1.16032 37.133L1.23088 36.8929L1.30379 36.6543L1.37874 36.4169L1.45574 36.1807L1.53509 35.9459L1.61678 35.7124L1.70081 35.4804L1.78718 35.2492L1.8759 35.0199L1.96695 34.7917L2.06035 34.5647L2.15668 34.3393L2.25535 34.115L2.35666 33.8922L2.4606 33.6706L2.56717 33.4505L2.67638 33.2319L2.78852 33.0147L2.90358 32.7988L3.02128 32.5844L3.14191 32.3711L3.26547 32.1597L3.39196 31.9494L3.52166 31.7406L3.65429 31.5333L3.78986 31.3275L3.92864 31.1229L4.07064 30.9201L4.21616 30.7188L4.3646 30.5187L4.51626 30.3203L4.67144 30.1235L4.83013 29.9281L4.99205 29.7343L5.15747 29.5419L5.3267 29.351L5.49916 29.1616L5.67512 28.974L5.85489 28.7879L6.03847 28.6033L6.22556 28.4202L6.41646 28.2389L6.61117 28.059L6.80968 27.881L7.01229 27.7044L7.21871 27.5293L7.42893 27.356L7.64325 27.1843L7.86167 27.0143L8.08419 26.8457L8.31081 26.679L8.54152 26.5138L8.77663 26.3503L9.01584 26.1887L9.25944 26.0285L9.50743 25.8702L9.75952 25.7136L10.0163 25.5588L10.2775 25.4055L10.543 25.254L10.8127 25.104L11.0864 24.956L11.364 24.8093L11.6454 24.6643L11.9303 24.5209L12.2187 24.3792L12.8057 24.1001L13.4047 23.8269L14.0149 23.5596L14.635 23.2978L15.2642 23.0413L15.9011 22.7901L16.5446 22.5438L17.1934 22.3025L18.5037 21.8331L19.8221 21.3809L22.449 20.5214L27.4109 18.9388L28.5381 18.5631L29.6021 18.192L30.108 18.008L30.5961 17.8246L31.0672 17.6418L31.5213 17.4595L31.9596 17.2776L32.3821 17.0963L32.7894 16.9146L33.182 16.7336L33.56 16.5523L33.9245 16.3709L34.2756 16.1893L34.6138 16.0074L34.9396 15.8248L35.098 15.7336L35.2535 15.642L35.4061 15.5504L35.556 15.4586L35.7029 15.3664L35.8473 15.2743L35.989 15.1818L36.1281 15.089L36.2648 14.996L36.3989 14.9029L36.5307 14.8093L36.6604 14.7156L36.7874 14.6217L36.9125 14.5271L37.0351 14.4326L37.1561 14.3375L37.2746 14.2423L37.3912 14.1466L37.5059 14.0505L37.619 13.9539L37.7302 13.857L37.8394 13.7597L37.9472 13.6619L38.0532 13.5638L38.1577 13.4654L38.2607 13.3664L38.3621 13.2667L38.4622 13.1665L38.5611 13.066L38.6586 12.9649L38.8501 12.7612L39.0369 12.5551L39.2202 12.3469L39.4 12.1361L39.5765 11.9228L39.7505 11.7069L39.9214 11.4889L40.0901 11.2688L40.2564 11.0466L40.4207 10.8223L40.5826 10.5962L40.7427 10.3683L41.0578 9.90815L41.3669 9.44258L43.7766 5.64259L44.0881 5.17284L44.4058 4.70757L44.5674 4.47673L44.7311 4.24797L44.8971 4.021L45.0654 3.79642L45.2367 3.57482L45.4106 3.3565L45.5875 3.14146L45.6771 3.03559L45.7679 2.9306L45.8592 2.82681L45.9514 2.72391L46.0445 2.62221L46.1385 2.5217L46.2337 2.42268L46.3297 2.32486L46.4266 2.22823L46.5247 2.13308L46.6237 2.03943L46.7238 1.94727L46.8251 1.85661L46.9273 1.76773L47.0309 1.68034L47.1355 1.59445L47.2415 1.51034L47.3483 1.42802L47.4566 1.34749L47.5664 1.26905L47.6771 1.19211L47.733 1.15453L47.7893 1.11724L47.8461 1.08086L47.9029 1.04447L47.9602 1.00898L48.0176 0.97379L48.0756 0.939185L48.1339 0.905189L48.1927 0.871485L48.2516 0.838682L48.311 0.80617L48.3707 0.774259L48.4308 0.74294L48.4911 0.711921L48.552 0.681803L48.6132 0.652276L48.6747 0.623041L48.7367 0.594707L48.7991 0.566673L48.8617 0.539531L48.925 0.51269L48.9882 0.486449L49.0524 0.461092L49.1165 0.436344L49.1812 0.411887L49.2462 0.388322L49.3118 0.365358L49.3776 0.342986L49.4441 0.321515L49.5106 0.300335L49.5779 0.280056L49.6455 0.260368L49.7135 0.241282L49.7817 0.222796L49.8508 0.205193L49.9199 0.1882L49.9896 0.171789L50.0598 0.15628L50.1304 0.141371L50.2015 0.127354L50.273 0.113637L50.3447 0.101104L50.4173 0.0888804L50.4899 0.0775486L50.5634 0.0671088L50.6372 0.0572606L50.7113 0.0483135L50.7859 0.0399671L50.8612 0.0325126L50.9367 0.0256498L51.0129 0.0196881L51.0896 0.0146184L51.1666 0.0101403L51.2442 0.00656323L51.3223 0.00357782L51.4008 0.00149349L51.4799 0.000301149L51.5595 7.84166e-07L73.3922 -1.7017e-07L81 -5.02719e-07L81 2.41105L81 65.5889L81 68L73.3922 68Z"
        />
      </svg>

      <image
        v-if="type == 'image'"
        :width="shapeData.width"
        :height="shapeData.height"
        :href="href"
        :transform="`rotate(${shapeData.rotation || 0} ${shapeData.x + shapeData.width / 2} ${
          shapeData.y + shapeData.height / 2
        })`"
      ></image>

      <g
        v-if="shapeData.label"
        :transform="`translate(${shapeData.label.position.x + shapeData.base.x}, ${
          shapeData.label.position.y + shapeData.base.y
        })`"
      >
        <text
          class="polygon-label"
          text-anchor="middle"
          dominant-baseline="middle"
          :style="`transform: rotate(${shapeData.label.rotation}deg); font-size: ${
            shapeData.label.size || 1.8
          }px`"
          :x="0"
          :y="0"
          >{{ shapeData.label.title }}</text
        >
      </g>

      <circle
        v-if="shapeData.badge && !venueReservationTable"
        class="badge"
        :class="shapeData.badge"
        :cx="badgeX"
        :cy="badgeY"
        :r="0.65"
      />

      <g class="reserved-table-x" v-if="showX">
        <line
          class="line-1 stroke-white"
          :x1="-shapeData.w + xMarkMargin"
          :y1="-shapeData.h + xMarkMargin"
          :x2="shapeData.w - xMarkMargin"
          :y2="shapeData.h - xMarkMargin"
          :stroke-width="2 / ratio"
        />

        <line
          class="line-2 stroke-white"
          :x1="-shapeData.w + xMarkMargin"
          :y1="shapeData.h - xMarkMargin"
          :x2="shapeData.w - xMarkMargin"
          :y2="-shapeData.h + xMarkMargin"
          :stroke-width="2 / ratio"
        />
      </g>

      <text
        v-if="showName"
        x="0"
        y="0"
        dominant-baseline="middle"
        text-anchor="middle"
        :transform="`rotate(${0 - (shapeData.rotation || 0)})`"
        class="venue-ui:font-label venue-ui:font-bold venue-ui:text-xs"
        >{{ shapeData.name }}</text
      >

      <text
        v-if="reservationTableSingle"
        x="0"
        y="0"
        dominant-baseline="middle"
        text-anchor="middle"
        class="emoji-checkmark font-xl"
        :transform="`rotate(${0 - (shapeData.rotation || 0)})`"
      >
        &#10003;
      </text>
      <text
        v-if="reservationTableOrderedList"
        x="0"
        y="0"
        dominant-baseline="middle"
        text-anchor="middle"
        class="font-xl font-semibold"
        :transform="`rotate(${0 - (shapeData.rotation || 0)})`"
      >
        {{ selectedTableOrder }}
      </text>
    </g>
  </g>
</template>

<style scoped>
text:not(.polygon-label) {
  font-size: 1.3px;
  fill: white;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.emoji-checkmark {
  font-size: 1.8px !important;
}

.polygon-label {
  font-size: 1.8px;
  fill: black;
}

@media screen and (max-width: 767px) {
  text {
    font-size: 0.9px;
  }

  .polygon-label {
    font-size: 1.4px;
  }
}

.unavailable .table {
  fill: rgb(64, 64, 64);
}

.reservation-table.unavailable .table {
  fill: rgb(209, 215, 217);
}

.guest-ui .active .table {
  fill: var(--primary-theme-color);
}

.venue-ui .active .table {
  fill: rgb(var(--colors-blue-10));
}

.venue-ui .edit-mode.active .table {
  fill: rgb(var(--colors-blue-10));
}

.available .table {
  fill: rgb(191, 191, 191);
}

.venue-ui .edit-mode.available .table {
  fill: white;
  stroke: rgb(var(--colors-blue-10));
  stroke-width: 0.1;
}

.venue-ui .edit-mode.available text {
  fill: rgb(var(--colors-blue-10));
}

.venue-ui .edit-mode.unavailable .table {
  fill: rgb(var(--colors-gray-20));
}

.venue-ui .edit-mode.unavailable text {
  fill: rgb(var(--colors-gray-40));
}

.venue-ui .line-1,
.venue-ui .line-2 {
  stroke: white;
  stroke-width: 0.1;
}

.reservation-table.available .table {
  fill: #404040;
}

.active .table,
.available .table {
  cursor: pointer;
}

.badge.seated {
  fill: rgb(119, 187, 77);
}

.badge.arrived {
  fill: rgb(11, 200, 250);
}

.badge.no-show {
  fill: rgb(255, 61, 25);
}
</style>

<script lang="ts">
import { defineComponent } from 'vue'

import { TableShape } from '@generated/types'

export default defineComponent({
  props: {
    type: {
      type: String,
      required: true,
    },
    shapeData: {
      type: Object,
      required: true,
    },
    orderedList: {
      type: Boolean,
      required: false,
    },
    useCheckmark: {
      type: Boolean,
      required: false,
    },
    ratio: {
      type: Number,
      required: true,
    },
    radius: {
      type: Number,
      required: false,
    },
    draggable: {
      type: Boolean,
      required: false,
      default: false,
    },
    selectable: {
      type: Boolean,
      required: true,
    },
    maxx: {
      type: Number,
      required: false,
    },
    maxy: {
      type: Number,
      required: false,
    },
    reservationTable: {
      type: Boolean,
      required: false,
      default: false,
    },
    venueReservationTable: {
      type: Boolean,
      required: false,
      default: false,
    },
    selectedTableOrder: {
      type: Number,
      required: false,
    },
    selectedTablesView: {
      type: Boolean,
      required: false,
      default: false,
    },
    assetsDomain: {
      type: String,
      required: false,
      default: '',
    },
  },

  data() {
    return {
      dragging: false,
      deltaX: 0,
      deltaY: 0,
      tooltip: false,
      original: {
        x: 0,
        y: 0,
      },
      TableShape,
    }
  },

  watch: {
    'shapeData.x'() {
      this.deltaX = 0
      this.deltaY = 0
    },
    'shapeData.y'() {
      this.deltaX = 0
      this.deltaY = 0
    },
  },

  created() {
    window.addEventListener('mousemove', this.onMouseMove)
    window.addEventListener('mouseup', this.onMouseUp)
    window.addEventListener('touchstart', this.onTouchStart)
  },

  beforeUnmount() {
    window.removeEventListener('mousemove', this.onMouseMove)
    window.removeEventListener('mouseup', this.onMouseUp)
    window.removeEventListener('touchstart', this.onTouchStart)
  },

  computed: {
    badgeX(): number {
      if (this.type == TableShape.CIRCLE || this.type == TableShape.HALF_CIRCLE) {
        return this.shapeData.w / Math.sqrt(2)
      }
      return this.shapeData.w
    },

    badgeY(): number {
      if (this.type == TableShape.CIRCLE || this.type == TableShape.HALF_CIRCLE) {
        return 0 - this.shapeData.h / Math.sqrt(2)
      }
      return 0 - this.shapeData.h
    },

    reservationTableSingle(): boolean {
      return (
        !!this.selectedTableOrder &&
        this.reservationTable &&
        (this.useCheckmark || !this.orderedList)
      )
    },

    reservationTableOrderedList(): boolean {
      return (
        !!this.selectedTableOrder && this.reservationTable && this.orderedList && !this.useCheckmark
      )
    },

    showName(): boolean {
      return this.shapeData.name && !this.reservationTable
    },

    status(): string[] {
      const classes: string[] = []
      if ((!!this.selectedTableOrder && this.selectable) || this.selectedTablesView) {
        classes.push('active')
      } else if (this.shapeData.available) {
        classes.push('available')
      } else {
        classes.push('unavailable')
      }

      if (this.shapeData.notFit) {
        classes.push('fill-gray-30')
      } else if (this.reservationTable) {
        classes.push('reservation-table')
      }

      return classes
    },

    showX(): boolean {
      return (
        (this.reservationTable && !this.shapeData.available) ||
        (this.venueReservationTable && !this.selectedTableOrder && !this.shapeData.available)
      )
    },

    pointsStr(): string {
      let str = ''
      const { points, base } = this.shapeData

      for (const point of points) {
        const x = point.x + base.x
        const y = point.y + base.y

        str = str + `${x},${y} `
      }

      return str.trim()
    },

    trianglePoints(): string {
      const { w, h } = this.shapeData
      return `${-w * 1.5},${h * 0.5} ${w * 0.5},${h * 0.5} ${w * 0.5},${-h * 1.5} ${-w * 1.5},${
        h * 0.5
      }`
    },

    href(): string {
      if (this.assetsDomain) {
        return '//' + this.assetsDomain + this.shapeData.href
      }
      return this.shapeData.href
    },

    xMarkMargin(): number {
      switch (this.type) {
        case TableShape.CIRCLE:
          return this.shapeData.w * 0.4
        case TableShape.HALF_CIRCLE:
          return this.shapeData.w * 0.7
        case TableShape.TRIANGLE:
          return 0.6
        case TableShape.SQUARE:
          return 0.6
        default:
          return 0.6
      }
    },
  },

  methods: {
    setTooltip(status) {
      if (status == this.tooltip) return

      this.$emit(status ? 'mouseover' : 'mouseout')
      this.tooltip = status
    },

    clamp(min, input, max) {
      return Math.max(min, Math.min(input, max))
    },

    offset(evt: MouseEvent, round = false) {
      const x = (evt.pageX - this.original.x) / this.ratio
      const y = (evt.pageY - this.original.y) / this.ratio

      if (round) {
        return {
          x: Math.round(x),
          y: Math.round(y),
        }
      }
      return { x, y }
    },

    clampedValue(evt: MouseEvent, round = false) {
      const { x, y } = this.offset(evt, round)
      return {
        x: this.clamp(0, x + this.shapeData.x, this.maxx),
        y: this.clamp(0, y + this.shapeData.y, this.maxy),
      }
    },

    clampedOffset(evt: MouseEvent, round = false) {
      const { x, y } = this.clampedValue(evt, round)
      return {
        x: x - this.shapeData.x,
        y: y - this.shapeData.y,
      }
    },

    onMouseDown(evt: MouseEvent) {
      if (this.draggable) {
        this.deltaX = 0
        this.deltaY = 0
        this.dragging = true
        this.original.x = evt.pageX
        this.original.y = evt.pageY
      }

      if (this.selectable) {
        this.$emit('select')
      }
    },

    onMouseMove(evt: MouseEvent) {
      if (this.dragging) {
        const { x, y } = this.clampedOffset(evt)
        this.deltaX = x
        this.deltaY = y
      }
    },

    onMouseUp(evt: MouseEvent) {
      if (this.dragging) {
        this.dragging = false

        const { x, y } = this.clampedValue(evt, true)
        this.deltaX = x - this.shapeData.x
        this.deltaY = y - this.shapeData.y
        this.$emit('update', { x, y })
      }
    },

    onTouchStart(evt: TouchEvent) {
      const el = this.$refs?.el as SVGGElement
      if (!el) {
        this.setTooltip(false)
        return
      }
      for (let i = 0; i < evt.touches.length; i++) {
        const touch = evt.touches.item(i)
        if (touch && touch.target instanceof Element && el.contains(touch.target)) {
          this.setTooltip(true)
          return
        }
      }
      this.setTooltip(false)
    },
  },
})
</script>
